import { Button } from "@newsela/angelou";
import { withTrackEvent } from "@newsela/snitch";
import PropTypes from "prop-types";

import CloseIcon from "@/icons/CloseIcon";
import {
  actionButtonCss,
  bodyCss,
  closeButtonCss,
  closeIconCSS,
  logoCss,
  rootCss,
} from "./Banner.style";

const propTypes = {
  __cssFor: PropTypes.object,
  bannerAriaLabel: PropTypes.string,
  closeButtonAriaLabel: PropTypes.string,
  bannerRef: PropTypes.any,
  children: PropTypes.node,
  eventProperties: PropTypes.object,
  onClose: PropTypes.func,
  logo: PropTypes.node,
};

const Banner = ({
  __cssFor,
  bannerAriaLabel,
  closeButtonAriaLabel,
  bannerRef,
  children,
  eventProperties,
  onClose,
  logo,
}) => {
  const ButtonWithTrackEvent = withTrackEvent(Button);

  return (
    <div
      role="region"
      aria-label={bannerAriaLabel}
      css={[rootCss, __cssFor?.rootCss]}
      ref={bannerRef}
    >
      <div css={[logoCss, __cssFor?.logoCss]}>{logo}</div>

      <div css={[bodyCss, __cssFor?.bodyCss]}>{children}</div>

      <div css={[actionButtonCss, __cssFor?.actionButtonCss]}>
        <ButtonWithTrackEvent
          ariaProps={{ "aria-label": closeButtonAriaLabel }}
          __cssFor={{ root: closeButtonCss }}
          flavor={Button.flavors.incognito}
          onClick={onClose}
          {...eventProperties}
        >
          <CloseIcon css={closeIconCSS} />
        </ButtonWithTrackEvent>
      </div>
    </div>
  );
};

Banner.propTypes = propTypes;

export default Banner;
